module.exports = __webpack_public_path__ + "static/media/left_align_white.9e4fc07a.svg";